import { Transaction } from 'types';
import { useEffect, useState } from 'react';
import { useAppSelector } from 'hooks/redux';
import { AssetQuantity } from 'components/ui/molecule/AssetQuantity';
import {
  Column,
  Description,
  IconStyled,
  Label,
  Left,
  LeftIcon,
  Middle,
  Right,
  Status,
  Wrapper,
} from './TransactionListItem.style';
import {
  getIcon,
  getTxnDate,
  getTxnFailureReason,
  getTxnStatus,
  getTxnType,
  getTxnValues,
} from './types';
import { openExplorerTab } from 'utils/utils';
import { ETH_TOKEN_ADDR } from 'utils/constants';

interface Props {
  transaction: Transaction;
}

export const TransactionListItemView = ({ transaction }: Props) => {
  const erc20TokenBalances = useAppSelector(
    (state) => state.wallet.erc20TokenBalances,
  );
  const erc20TokenBalanceSelected = useAppSelector(
    (state) => state.wallet.erc20TokenBalanceSelected,
  );
  const locale = useAppSelector((state) => state.wallet.locale);
  const [currencySymbol, setCurrencySymbol] = useState('N/A');
  const [txnValue, setTxnValue] = useState('0');
  const [txnUsdValue, setTxnUsdValue] = useState('0.00');
  const tokenAddress = erc20TokenBalanceSelected.instrumentAdmin;

  const walletAddress = useAppSelector(
    (state) => state.wallet.currentAccount.address,
  );

  useEffect(() => {
    const fetchData = async () => {
      // Find the matching token
      const foundToken = erc20TokenBalances.find(
        (token) => token.instrumentAdmin === ETH_TOKEN_ADDR,
      );
      console.log('foundToken', foundToken);
      if (foundToken) {
        const txnValues = getTxnValues(
          transaction,
          foundToken.decimals,
          foundToken.usdPrice,
          tokenAddress,
          walletAddress,
        );
        console.log('txnValues', txnValues);
        setTxnValue(txnValues.txnValue);
        setTxnUsdValue(txnValues.txnUsdValue);
        setCurrencySymbol(foundToken.symbol);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const txnName = getTxnType(transaction, tokenAddress);
  const txnDate = getTxnDate(transaction, locale);
  const txnStatus = getTxnStatus(transaction);
  const txnToFromLabel = '';
  const txnFailureReason = getTxnFailureReason(transaction);
  return (
    <Wrapper
      onClick={() =>
        openExplorerTab(transaction.updateId, 'updates', transaction.chainId)
      }
    >
      <Left>
        <LeftIcon>
          <IconStyled transactionname={txnName} icon={getIcon(txnName)} />
        </LeftIcon>
        <Column>
          <Label>{transaction.updateId}</Label>
          <Description>
            {txnDate}
            <br />
            <Status status={transaction.executionStatus}>
              {txnStatus}
              {txnFailureReason}
            </Status>
          </Description>
        </Column>
      </Left>
      <Middle>{txnToFromLabel} </Middle>
      <Right>
        <AssetQuantity
          currency={currencySymbol}
          currencyValue={txnValue}
          USDValue={txnUsdValue}
        />
      </Right>
    </Wrapper>
  );
};
